import {
    GET_USER_DATA,
    GET_USER_DATA_SUCCESS,
    GET_USER_DATA_ERROR,
    LOGOUT_USER,
    LOGOUT_USER_SUCCESS,
    // LOGOUT_USER_ERROR,
    ADD_PROCEEDING,
    ADD_PROCEEDING_SUCCESS,
    ADD_PROCEEDING_ERROR,
    REMOVE_PROCEEDING,
    REMOVE_PROCEEDING_SUCCESS,
    REMOVE_PROCEEDING_ERROR
} from '../types';

//Cada reducer tiene su propio state
const initialState = {
    error: null,
    loading: false,
    user: null,
    proceedings: null,
    loadingAdd: false
}

export default function authReducer(state = initialState, action) {
    switch(action.type){
        case GET_USER_DATA:
        case LOGOUT_USER:
            return {
                ...state,
                loading: true
            }
        case GET_USER_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                user: action.payload.user,
                proceedings: action.payload.proceedings
            }
        case GET_USER_DATA_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload
            }
        case LOGOUT_USER_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                user: null,
                proceedings: null
            }
        case ADD_PROCEEDING:
        case REMOVE_PROCEEDING:
            return {
                ...state,
                loadingAdd: true
            }
        case ADD_PROCEEDING_SUCCESS:
            return {
                ...state,
                loadingAdd: false,
                proceedings: [...state.proceedings, action.payload]
            }
        case ADD_PROCEEDING_ERROR:
        case REMOVE_PROCEEDING_ERROR:
            return {
                ...state,
                loadingAdd: false,
                error: null
            }
        case REMOVE_PROCEEDING_SUCCESS:
            return {
                ...state,
                loadingAdd: false,
                proceedings: state.proceedings.filter(p => p.id !== action.payload.id)
            }
        default:
            return state;
    }
}